import Basic from "components/area-measures/controls/basic"
import Detailed from "components/area-measures/controls/detailed"
import Percent from "components/area-measures/controls/percent"
import DeleteConfirmation from "components/modal/delete-confirmation"

export default {
  Basic,
  Detailed,
  Percent,
  DeleteConfirmation
}
